import { IRootStoreExporter, VIEW } from './interfaces';
import { makeAutoObservable } from 'mobx';
import { API_CACHE_KEYS } from './services/lib/APIServiceInterfaces';
import StorageService from './services/StorageService';

export class AppStore implements IRootStoreExporter {
    public readonly isCountryPageOn: boolean = false;
    public currentDisplayedView: VIEW = VIEW.RISK_VIEW;
    private isDebugMode: boolean;
    private firstLoad: boolean;
    public impersonate =
        StorageService.get(API_CACHE_KEYS.IMPERSONATE) !== null;


    private lastGroupId: string;
    constructor() {
        makeAutoObservable(this)
        this.toInitialState();
    }

    public setCurrentDisplayView(view: VIEW) {
        this.currentDisplayedView = view;
    }

    public exportKeys(): any {
        return [];
    }
    public setLastGroup(id: string) {
        this.lastGroupId = id;
    }

    public get LastGroupID() {
        return this.lastGroupId;
    }

    public get isFirstLoad() {
        return this.firstLoad;
    }

    public setImpersonate(value: boolean) {
        this.impersonate = value;
    }

    public setfirstLoad(value: boolean) {
        this.firstLoad = value;
    }
    public toInitialState() {
        this.isDebugMode = false;
    }

    public setDebugMode(v: boolean) {
        this.isDebugMode = v;
    }

    get debugMode() {
        return this.isDebugMode;
    }
}

const appStore = new AppStore();
export default appStore;
